import React from 'react'

import { useFormikContext } from 'formik'

import ActualPage from 'presentation/shared/components/ActualPage'
import Heading from 'presentation/shared/components/Heading'
import SupportText from 'presentation/shared/components/SupportText'
import Checkbox from 'presentation/shared/components/Checkbox'
import { Container } from 'presentation/shared/components/Container'
import Button from 'presentation/shared/components/Button'
import { ActingSectors as ActingSectorsEnum } from 'common/enum/acting-sectors'

import * as S from './styles'
import getRegisterDoctorButtonLabel from 'common/utils/getRegisterDoctorButtonLabel'
import { AddDoctorInfoFormValues } from '../../../../pages/AddDoctorInfo/add-doctor-info-form-values'
import isOriginDoctorRegisterResume from '../../../../../../common/utils/isOriginFromDoctorRegisterResume'

type Props = {
  goBack(): void
  stepActiveIndex: number
  totalSteps: number
  onSubmit(): void
  onContinueLater(): void
}

const ActingSectors = ({
  goBack,
  stepActiveIndex,
  totalSteps,
  onSubmit,
  onContinueLater
}: Props) => {
  const { values, errors, setFieldValue } =
    useFormikContext<AddDoctorInfoFormValues>()

  const handleCheckActingSector = (value: string) => {
    const actingSectors = values.actingSectors ?? []
    const findedActingSector = actingSectors.find(
      (actingSector) => actingSector === value
    )
    if (findedActingSector) {
      const filteredActingSectors = actingSectors.filter(
        (actingSector) => actingSector !== value
      )
      setFieldValue('actingSectors', filteredActingSectors)
      return
    }
    setFieldValue('actingSectors', [...actingSectors, value])
  }

  return (
    <Container
      primaryButton={
        isOriginDoctorRegisterResume() ? (
          <Button
            fullWidth
            onClick={() => onSubmit()}
            disabled={!!errors.actingSectors}
          >
            Próximo
          </Button>
        ) : undefined
      }
      secondaryButton={
        <Button fullWidth onClick={() => onContinueLater()} variant="white">
          {getRegisterDoctorButtonLabel()}
        </Button>
      }
      progressBar={
        isOriginDoctorRegisterResume()
          ? {
              totalSteps: totalSteps,
              activeStep: stepActiveIndex
            }
          : undefined
      }
    >
      <S.FormWrapper>
        <ActualPage onClick={() => goBack()} text="Voltar" />
        <Heading size="large" as="h1">
          Setores de Atuação
        </Heading>
        <SupportText color="lightGray">
          Selecione os setores onde você irá atuar no hospital
        </SupportText>
        <S.ActingSectors>
          <SupportText color="primary">Setores de Atuação</SupportText>
          <SupportText color="lightGray">
            Deve ser selecionado pelo menos um setor de atuação
          </SupportText>
          {actingSectorsOptions.map((actingSector) => (
            <Checkbox
              key={actingSector.value}
              label={actingSector.label}
              value={actingSector.value}
              labelFor={`${actingSector.label} - ${actingSector.value}`}
              onCheck={() => handleCheckActingSector(actingSector.value)}
              checked={
                !!values.actingSectors?.find(
                  (actingSectorItem) => actingSectorItem === actingSector.value
                )
              }
            />
          ))}
        </S.ActingSectors>
      </S.FormWrapper>
    </Container>
  )
}

export const actingSectorsOptions = [
  {
    label: 'Pronto Socorro (PSO)',
    value: ActingSectorsEnum.EMERGENCY_ROOM
  },
  {
    label: 'Unidade de Internação (UIN)',
    value: ActingSectorsEnum.INPATIENT_UNIT
  },
  {
    label: 'Centro de Tratamento Intensivo (CTI-Geral)',
    value: ActingSectorsEnum.INTENSIVE_TREATMENT_CENTER
  },
  {
    label: 'Centro de Tratamento Intensivo - Unidade Coronariana (CTI-UCO)',
    value: ActingSectorsEnum.INTENSIVE_TREATMENT_CENTER_CORONARY
  },
  {
    label: 'Unidade de Terapia Intensiva Neonatal (UTIN)',
    value: ActingSectorsEnum.NEONATAL_INTENSIVE_CARE_UNIT
  },
  {
    label: 'Unidade de Terapia Intensiva Pediátrica (UTIP)',
    value: ActingSectorsEnum.PEDIATRIC_INTENSIVE_CARE_UNIT
  },
  {
    label: 'Ambulatório (AMB)',
    value: ActingSectorsEnum.AMBULATORY
  },
  {
    label: 'Centro Cirúrgico (CCI)',
    value: ActingSectorsEnum.SURGICAL_CENTER
  },
  {
    label: 'Centro de Feridas (CFE)',
    value: ActingSectorsEnum.WOUND_CENTER
  },
  {
    label: 'Oncologia (ONC)',
    value: ActingSectorsEnum.ONCOLOGY
  },
  {
    label: 'Medicina Diagnóstica (MDG)',
    value: ActingSectorsEnum.DIAGNOSTIC_MEDICINE
  },
  {
    label: 'Hemodinâmica (HEM)',
    value: ActingSectorsEnum.HEMODYNAMICS
  },
  {
    label: 'Endoscopia (END)',
    value: ActingSectorsEnum.ENDOSCOPY
  }
]

export default ActingSectors
